module.exports = __webpack_public_path__ + "static/image1996-cd10f3577a46b1ff41fa56a9d9c82dba.jpeg";